module.exports = __webpack_public_path__ + "static/media/37import-72.544773f5.xlsx";